import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";
import Input from "components/bootstrap/Input";
import { Panel } from "components/bootstrap";
import WatchlistSelector from "./WatchlistSelector";
const StyledInlineCode = styled("code")`
  margin: 0 0.25em;
  white-space: nowrap;
`;
const WatchlistParameterForm = ({
  idx,
  onChange,
  validationState,
  parameter,
  onValidate
}) => {
  var _a, _b;
  const { watchlistId, name } = parameter;
  const parameterSyntax = `$${name}$`;
  useEffect(() => {
    const state = watchlistId ? ["success"] : ["error", "Please select a watchlist"];
    onValidate(idx, { watchlistId: state });
    return () => onValidate(idx, { watchlistId: ["success"] });
  }, [watchlistId, idx, onValidate]);
  const _onChange = (selectedId) => onChange("watchlistId", selectedId);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `watchlist-${idx}`,
      name: "watchlistId",
      label: "Watchlist",
      bsStyle: (_a = validationState == null ? void 0 : validationState.watchlistId) == null ? void 0 : _a[0],
      help: (_b = validationState == null ? void 0 : validationState.watchlistId) == null ? void 0 : _b[1]
    },
    /* @__PURE__ */ React.createElement(WatchlistSelector, { id: `watchlist-selector-${idx}`, value: watchlistId, onChange: _onChange })
  ), /* @__PURE__ */ React.createElement(Panel, { id: "watchlist-parameter-help" }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, { toggle: true }, "How to use watchlist parameters")), /* @__PURE__ */ React.createElement(Panel.Collapse, null, /* @__PURE__ */ React.createElement(Panel.Body, null, /* @__PURE__ */ React.createElement("h5", null, "General Usage"), /* @__PURE__ */ React.createElement("p", null, "After declaring it, the parameter", /* @__PURE__ */ React.createElement(StyledInlineCode, null, parameterSyntax), "in your query, will be replaced with the list of entries in the watchlist. The list of results will be presented in the form of a Lucene BooleanQuery. E.g.:", /* @__PURE__ */ React.createElement(StyledInlineCode, null, '("foo" OR "bar" OR "baz")')), /* @__PURE__ */ React.createElement("h5", null, "Limitations"), /* @__PURE__ */ React.createElement("p", null, "Please note, the maximum number of supported results is depending on the", /* @__PURE__ */ React.createElement(StyledInlineCode, null, "opensearch_indices_query_bool_max_clause_count"), " setting. If the watchlist entries ends up generating a larger query, the query will fail in your indexer.")))));
};
export default WatchlistParameterForm;
